// @flow

import {
  GET_FILTERS_REQUEST,
  GET_FILTERS_SUCCESS,
  GET_FILTERS_FAILURE,
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
} from '../actions/exportsView';
import {combineReducers} from 'redux';
import _ from 'lodash/fp';

const defaultFilterOptionsState = {
  projects: [],
  suppliers: [],
  productTypes: [],
  workerTypes: [],
  roomTypes: [],
  isFetching: false,
};

const filterOptions = (state = defaultFilterOptionsState, action) => {
  switch (action.type) {
    case GET_FILTERS_SUCCESS:
      return {
        ...state,
        ...action.data,
        isFetching: false,
        error: null,
      };
    case GET_FILTERS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case GET_FILTERS_FAILURE:
      return {
        ...state,
        isFetching: true,
        error: action.error,
      };
    default:
      return state;
  }
};

const defaultCurrentSelectionState = {
  rows: [],
  projects: [],
  suppliers: [],
  productTypes: [],
  workerTypes: [],
  roomTypes: [],
  assortments: [],
  downloadUri: null,
  isFetching: false,
  totalQuantity: 0,
  totalPrice: 0,
};

const currentSelection = (state = defaultCurrentSelectionState, action) => {
  switch (action.type) {
    case GET_FILTERS_SUCCESS:
      return defaultCurrentSelectionState;
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        ...action.data,
        totalQuantity: _.sumBy('quantity', action.data.rows),
        totalPrice: _.sumBy('price', action.data.rows),
        isFetching: false,
        error: null,
      };
    case FETCH_DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FETCH_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default combineReducers({currentSelection, filterOptions});



// WEBPACK FOOTER //
// ./src/reducers/exportsView.js